import Icon from '@ant-design/icons';
import classNames from 'classnames';

import CloseSvg from '@/components/Icon/svgs/close.svg';
import { CONTAINER_EVENT } from '@/components/chat-app/utils/utils';
import useStorage from '@/hooks/useStorage';
import { EVENT } from '@/utils/event';
import reportClick, { EReportClickKey } from '@/utils/report/reportClick';

import styles from './index.less';

interface IProps {
  clearSession?: boolean;
}

export default function CloseIcon(props: IProps): JSX.Element {
  const { clearSession } = props;

  const [_, setOnboard] = useStorage('onboard');

  return (
    <div
      className={classNames(styles.buttonItem, { [styles.onlyIcon]: true })}
      id="hideScreen"
      onClick={() => {
        reportClick(EReportClickKey.clicked_hide_screen);
        dispatchEvent(new CustomEvent(EVENT.CHANGE_CHAT_STATUS_LAYOUT, { detail: 'hide' }));

        if (clearSession) {
          dispatchEvent(new Event(CONTAINER_EVENT.CLOSE_SESSION));
          setOnboard(true);
        }
      }}
    >
      <Icon className={styles.icon} component={CloseSvg} />
    </div>
  );
}
